export const SWIPE_MODE_SHOW_TUTORIAL = 'swipe_mode_show_tutorial';
export const SWIPE_MODE_SHOW_PASS_CONFIRMATION = 'swipe_mode_show_pass_confirmation';
export const SWIPE_MODE_SHOW_OFFER_CONFIRMATION = 'swipe_mode_show_offer_confirmation';
export const IS_ACCOUNT_INSTALLED_PWA_IN_IOS = 'is_account_installed_pwa_in_ios';
export const OFFER_ONE_TAP_MODE_SHOW_TUTORIAL = 'offer_one_tap_mode_show_tutorial';
